import React, { useEffect } from 'react';
// import { Link as RouterLink } from 'react-router-dom'; // Unused
// import ScaleIcon from '@mui/icons-material/Scale'; // Unused
// import HandshakeIcon from '@mui/icons-material/Handshake'; // Unused
// import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'; // Unused
// import GavelIcon from '@mui/icons-material/Gavel'; // Unused
// import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'; // Unused
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance'; // Unused
// import WorkIcon from '@mui/icons-material/Work'; // Unused
// import PeopleIcon from '@mui/icons-material/People'; // Unused
import {
    Box,
    Typography,
    // Grid, 
    // Paper,
    // Container,
    // Stack,
    // useTheme,
    // alpha
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Unused
import SectionWrapper from '../components/SectionWrapper';

const GovernancePage = () => {
    const navigate = useNavigate();
    const offBlack = '#0a0a0a';
    const defaultGovernanceSlug = 'integrity-program-governance-policy';

    useEffect(() => {
        // Entrada padrão do Programa de Integridade.
        navigate(`/governanca/${defaultGovernanceSlug}`, { replace: true });
    }, [navigate, defaultGovernanceSlug]);

    return (
        <SectionWrapper
            id="governance-page"
            sx={{ backgroundColor: offBlack }}
        >
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ color: 'white', opacity: 0.5, letterSpacing: '0.2rem', fontWeight: 700 }}>
                    CARREGANDO PROTOCOLOS CORPORATIVOS...
                </Typography>
            </Box>
        </SectionWrapper>
    );
};

export default GovernancePage;
